// https://github.com/amikelive/coco-labels
export const data = [
  { id: 1, active: false, tts: "五郎喔", class: "person" },
  { id: 2, active: false, tts: "bicycle", class: "bicycle" },
  { id: 3, active: false, tts: "五掐喔", class: "car" },
  { id: 4, active: false, tts: "motorcycle", class: "motorcycle" },
  { id: 5, active: false, tts: "airplane", class: "airplane" },
  { id: 6, active: false, tts: "bus", class: "bus" },
  { id: 7, active: false, tts: "train", class: "train" },
  { id: 8, active: false, tts: "truck", class: "truck" },
  { id: 9, active: false, tts: "boat", class: "boat" },
  { id: 10, active: false, tts: "traffic light", class: "traffic light" },
  { id: 11, active: false, tts: "fire hydrant", class: "fire hydrant" },
  { id: 12, active: false, tts: "street sign", class: "street sign" },
  { id: 13, active: false, tts: "stop sign", class: "stop sign" },
  { id: 14, active: false, tts: "parking meter", class: "parking meter" },
  { id: 15, active: false, tts: "bench", class: "bench" },
  { id: 16, active: false, tts: "bird", class: "bird" },
  { id: 17, active: false, tts: "喵喵", class: "cat" },
  { id: 18, active: false, tts: "旺旺", class: "dog" },
  { id: 19, active: false, tts: "horse", class: "horse" },
  { id: 20, active: false, tts: "sheep", class: "sheep" },
  { id: 21, active: false, tts: "cow", class: "cow" },
  { id: 22, active: false, tts: "elephant", class: "elephant" },
  { id: 23, active: false, tts: "bear", class: "bear" },
  { id: 24, active: false, tts: "zebra", class: "zebra" },
  { id: 25, active: false, tts: "giraffe", class: "giraffe" },
  { id: 26, active: false, tts: "hat", class: "hat" },
  { id: 27, active: false, tts: "backpack", class: "backpack" },
  { id: 28, active: false, tts: "umbrella", class: "umbrella" },
  { id: 29, active: false, tts: "shoe", class: "shoe" },
  { id: 30, active: false, tts: "eye glasses", class: "eye glasses" },
  { id: 31, active: false, tts: "handbag", class: "handbag" },
  { id: 32, active: false, tts: "tie", class: "tie" },
  { id: 33, active: false, tts: "suitcase", class: "suitcase" },
  { id: 34, active: false, tts: "frisbee", class: "frisbee" },
  { id: 35, active: false, tts: "skis", class: "skis" },
  { id: 36, active: false, tts: "snowboard", class: "snowboard" },
  { id: 37, active: false, tts: "sports ball", class: "sports ball" },
  { id: 38, active: false, tts: "kite", class: "kite" },
  { id: 39, active: false, tts: "baseball bat", class: "baseball bat" },
  { id: 40, active: false, tts: "baseball glove", class: "baseball glove" },
  { id: 41, active: false, tts: "skateboard", class: "skateboard" },
  { id: 42, active: false, tts: "surfboard", class: "surfboard" },
  { id: 43, active: false, tts: "tennis racket", class: "tennis racket" },
  { id: 44, active: false, tts: "bottle", class: "bottle" },
  { id: 45, active: false, tts: "plate", class: "plate" },
  { id: 46, active: false, tts: "wine glass", class: "wine glass" },
  { id: 47, active: false, tts: "來杯可樂吧", class: "cup" },
  { id: 48, active: false, tts: "fork", class: "fork" },
  { id: 49, active: false, tts: "knife", class: "knife" },
  { id: 50, active: false, tts: "spoon", class: "spoon" },
  { id: 51, active: false, tts: "bowl", class: "bowl" },
  { id: 52, active: false, tts: "banana", class: "banana" },
  { id: 53, active: false, tts: "apple", class: "apple" },
  { id: 54, active: false, tts: "sandwich", class: "sandwich" },
  { id: 55, active: false, tts: "orange", class: "orange" },
  { id: 56, active: false, tts: "broccoli", class: "broccoli" },
  { id: 57, active: false, tts: "carrot", class: "carrot" },
  { id: 58, active: false, tts: "hot dog", class: "hot dog" },
  { id: 59, active: false, tts: "pizza", class: "pizza" },
  { id: 60, active: false, tts: "donut", class: "donut" },
  { id: 61, active: false, tts: "cake", class: "cake" },
  { id: 62, active: false, tts: "能站就不要坐", class: "chair" },
  { id: 63, active: false, tts: "couch", class: "couch" },
  { id: 64, active: false, tts: "potted plant", class: "potted plant" },
  { id: 65, active: false, tts: "bed", class: "bed" },
  { id: 66, active: false, tts: "mirror", class: "mirror" },
  { id: 67, active: false, tts: "dining table", class: "dining table" },
  { id: 68, active: false, tts: "window", class: "window" },
  { id: 69, active: false, tts: "desk", class: "desk" },
  { id: 70, active: false, tts: "toilet", class: "toilet" },
  { id: 71, active: false, tts: "door", class: "door" },
  { id: 72, active: false, tts: "賣購跨點系阿", class: "tv" },
  { id: 73, active: false, tts: "我是天才小駭客", class: "laptop" },
  { id: 74, active: false, tts: "mouse", class: "mouse" },
  { id: 75, active: false, tts: "remote", class: "remote" },
  { id: 76, active: false, tts: "keyboard", class: "keyboard" },
  { id: 77, active: false, tts: "cell phone", class: "cell phone" },
  { id: 78, active: false, tts: "microwave", class: "microwave" },
  { id: 79, active: false, tts: "oven", class: "oven" },
  { id: 80, active: false, tts: "toaster", class: "toaster" },
  { id: 81, active: false, tts: "sink", class: "sink" },
  { id: 82, active: false, tts: "refrigerator", class: "refrigerator" },
  { id: 83, active: false, tts: "blender", class: "blender" },
  { id: 84, active: false, tts: "有黃金", class: "book" },
  { id: 85, active: false, tts: "時間就是金錢　朋友", class: "clock" },
  { id: 86, active: false, tts: "vase", class: "vase" },
  { id: 87, active: false, tts: "scissors", class: "scissors" },
  { id: 88, active: false, tts: "雄雄", class: "teddy bear" },
  { id: 89, active: false, tts: "hair drier", class: "hair drier" },
  { id: 90, active: false, tts: "toothbrush", class: "toothbrush" },
  { id: 91, active: false, tts: "hair brush", class: "hair brush" },
];
